var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('h1',[_vm._v("Signed out")])]),_c('v-row',[_c('button',{on:{"click":_vm.signIn}},[_vm._v("click here to sign in")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }